import React from "react";
import { useRef } from "react";
import "./Footer.css";
import Logo from "../Logo/Logo";
import phoneImage from "../../images/phone-image.svg";
import addressImage from "../../images/address-image.svg";
import mailImage from "../../images/mail-image.svg";

function Footer({ isLoading, scrollItem, onScrollItem }) {
  const footerRef = useRef();

  React.useEffect(()=>{
    if (scrollItem === "footer") {
      onScrollItem(footerRef);
    }
  },[onScrollItem,scrollItem])


  return (
    <>
      <footer ref={footerRef} className={`footer page__container ${isLoading ? "inactive" : "active appear"}`}>
        <div className="footer__logo-container">
          <Logo />
        </div>
        <div className="footer__contacts-container">
          <h2 className="footer__contacts-title">Контакты</h2>
          <nav>
            <ul className="footer__contacts-items">
              <li className="footer__address">
                <img
                  className="footer__contacts-icon"
                  src={addressImage}
                  alt="Изображение отметки на карте"
                />
                <a
                  className="footer__contacts-link"
                  href="https://yandex.ru/maps/?pt=40.941438,57.790396&z=18&l=map"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Юр. адрес: 156007, г. Кострома, ул. Ленина, д. 151, помещ. 132
                </a>
              </li>
              <li className="footer__address">
                <img
                  className="footer__contacts-icon"
                  src={addressImage}
                  alt="Изображение отметки на карте"
                />
                <a
                  className="footer__contacts-link"
                  href="https://yandex.ru/maps/?pt=43.947749,56.227250&z=18&l=map"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                 Почт. адрес: 603137, г. Нижний Новгород, ул. 40 лет Победы, д. 4, пом. П7
                </a>
              </li>
              <li className="footer__item">
                <img
                  className="footer__contacts-icon"
                  src={phoneImage}
                  alt="Изображение трубки телефона"
                />
                <a className="footer__contacts-link" href="tel:+78314158787">
                  +7 (831) 415-87-87
                </a>
              </li>
              <li className="footer__item">
                <img
                  className="footer__contacts-icon"
                  src={mailImage}
                  alt="Изображение почты"
                />
                <a
                  className="footer__contacts-link"
                  href="mailto:info@rek-21.ru"
                >
                  info@rek-21.ru
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </footer>
    </>
  );
}

export default Footer;
